
import { granjaApi } from "../../api";
import Swal from "sweetalert2";





export const usuarioPorID = async(id) => {
    try {
        const { data } = await granjaApi.get(`/usuario/porid/${id}`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}



export const listadoUsuariosRol = async({ page=0, termino='', rol }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);
        params.append('rol',  rol);

        const { data } = await granjaApi.get('/usuario/todos', { params });
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}



export const listadoTodosSegunRole = async(rol) => {
    try {
        const { data } = await granjaApi.get(`/usuario/xtodos/${rol}`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}



export const bloquearUserService = async(id) => {
    try {
        const { data } = await granjaApi.put(`/usuario/bloqueo/${id}`);
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        return false;
    }
}



export const startSavingUsuario = async( user ) => {
    try {
        if( user.id ){
            const { data } = await granjaApi.put(`/usuario/update/${user.id}`, user );
            Swal.fire('Exitoso', 'Usuario Actualizado', 'success');
            return true;
        }else {
            const { data } = await granjaApi.post('/usuario/new', user );
            Swal.fire('Exitoso', 'Usuario Creado', 'success');
            return true;
        }
    } catch (error) {
        console.log(error);
        Swal.fire('Error', error.response.data?.msg || '', 'error');
        return false;
    }
} 





